import angular = require("angular");
import TPL = require("templates");
import {EventData} from "../../models/contracts";
import {Config} from "../../config";
import {ConfirmController} from "../../modals/confirm";


export class EventTableDirective {

  template = TPL.contentDirectives.eventTable;
  scope = {
    params: "=params",
    events: "="
  };
  link;

  constructor(session, $log) {

    this.link = (scope, el, attrs) => {
      scope.vm = {
        session: session,
        loadMore: (type) => {
          //$log.debug("loadMore(" + type +")");
          if (type == "hosted") {
            session.loadMoreHostedEvents();
          } else if (type == "saved") {
            session.loadMoreSavedEvents();
          } else if (type == "past") {
            session.loadMorePastEvents();
          }
        }
      }
    };

  }

  static factory() {
    var tmp = (a, b) => new EventTableDirective(a, b);
    tmp.$inject = ["session", "$log"];
    return tmp;
  }
}

/**
  Params:
  type: one of 'landing', 'manage' or compact, defaults to 'landing'
*/
export class EventListDirective {

  template = TPL.contentDirectives.eventList;
  scope = {
    params: "=params"
  };
  link;

  constructor(session, $log) {

    this.link = (scope, el, attrs) => {
      scope.vm = {
        session: session,
        loadMore: (type) => {
          //TODO the infinite-scroll directive leaks a timer and this log is repeated also changing page...
          //$log.debug("loadMore(" + type +")");
          if (type == "manage") {
            session.loadMoreUpcomingEvents();
          } else {
            if (session.isLogged()) {
              session.loadMorePrivateEvents();
            } else {
              session.loadMorePublicEvents();
            }
          }

        }
      }
    };

  }

  static factory() {
    var tmp = (a, b) => new EventListDirective(a, b);
    tmp.$inject = ["session", "$log"];
    return tmp;
  }

}


export class EventRowDirective {

  template = TPL.contentDirectives.eventRow;
  scope = {
    params: "=params"
  };
  link;

  constructor($location, $modal, session) {

    this.link = (scope, el, attrs) => {

      scope.vm = {
        showEvent() {
          $location.url(Config.events + "/" + scope.params.item.uuid);
        },
        getReservationsList() {
          var reservationStats = scope.params.item.reservations_stats;
          return reservationStats.reservations_total;
        },
        getAcceptedList() {
          var reservationStats = scope.params.item.reservations_stats;
          //return reservationStats.reservations_accepted;
          return reservationStats.guests_accepted;
        },
        getPendingList() {
          var reservationStats = scope.params.item.reservations_stats;
          //return reservationStats.reservations_pending;
          return reservationStats.guests_pending;
        },
        getGuestsCount() {
          var reservationStats = scope.params.item.reservations_stats;
          return reservationStats.guests_total;
        },
        getAcceptedCount() {
          var reservationStats = scope.params.item.reservations_stats;
          return reservationStats.guests_accepted;
        },
        getPendingCount() {
          var reservationStats = scope.params.item.reservations_stats;
          return reservationStats.reservations_pending;
        },
        getGuestsList() {
          var guestsList = scope.params.item.reservations;
          var guestEmails;
          angular.forEach(guestsList, (guestsListItem) => {
              guestEmails.push(guestsListItem.profile.first_name);
          });
          //return reservationStats.reservations_accepted;
          return guestsList;
        },
      };
    }

  }

  static factory() {
    var tmp = (a, b, c) => new EventRowDirective(a, b, c);
    tmp.$inject = ["$location", "$uibModal", "session"];
    return tmp;
  }
}


export class EventDirective {

  template = TPL.contentDirectives.event;
  scope = {
    params: "=params"
  };
  link;

  constructor($location, $modal) {

    this.link = (scope, el, attrs) => {

        scope.vm = {
          getReservationsList() {
            var reservationList = scope.params.item.reservations;
            var reservationListFiltered = [];

            angular.forEach(reservationList, (reservationListItem) => {
              if(reservationListItem.state != "rejected") {
                reservationListFiltered.push(reservationListItem);
              }
            });

            return reservationListFiltered;
          },
          getPendingList() {
            var reservationList = scope.params.item.reservations;
            var reservationListFiltered = [];

            angular.forEach(reservationList, (reservationListItem) => {
              if(reservationListItem.state == "pending") {
                reservationListFiltered.push(reservationListItem);
              }
            });

            return reservationListFiltered;
          },
          showEvent() {
            if(scope.params.item.event_type == "private" && !scope.params.item.hosted_by_me && (scope.params.item.my_reservation == undefined || scope.params.item.my_reservation.state !=="accepted")) {
              var modalPrivate = ConfirmController.openPrivateDinnerModal($modal, () => {
                modalPrivate.dismiss();
              });
            } else {
              $location.path(Config.events + "/" + scope.params.item.uuid);
            }

            //$location.replace();
          },
          getAvatarSize() {
            switch (scope.params.type) {
              case "manage":
                return "sm";
              case "compact":
                return "sm";
              case "landing":
              default:
                return "lg";

            }
          },
          getAvatarPosition() {
            return scope.params.type == "manage" ? "left" : "";
          },
          getAvatarLabel() {
            if (scope.params.type != "compact" && scope.params.item.created_by_profile) {
              return scope.params.item.created_by_profile.first_name;
            }

            return " ";
          },
          linkPublicEvent() {
            var eventLink;
            if(scope.params.item.event_type == "private") {
              if(scope.params.type ==="manage") {
                eventLink = "#/events/" + scope.params.item.uuid;
              } else if(scope.params.item.my_reservation != undefined && scope.params.item.my_reservation.state ==="accepted"){
                eventLink = "#/events/" + scope.params.item.uuid;
              } else {
                eventLink = "";
              }
            } else {
              eventLink = "#/events/" + scope.params.item.uuid;
            }
            return eventLink;
          },
        };
    }

  }

  static factory() {
    var tmp = (a, b) => new EventDirective(a, b);
    tmp.$inject = ["$location", "$uibModal"];
    return tmp;
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/content/event.ts
 **/